import React, { useState } from "react";
import moment from "moment";

const FuelRateDuplicateDialogValidator = (props) => {
  const record = props.record;

  const [state, setState] = useState({

    error: null,
    errorMessage: null,
    field: null,
  }); 

  let field = null;
  let error = false;
  let errorMessage = "";

  if (!moment(record.validFrom).isValid()) {
    error = true;
    errorMessage = "Please enter a valid 'Valid From' date";
    field = "validFrom";
  } else if (!moment(record.validTo).isValid()) {
    error = true;
    errorMessage = "Please enter a valid 'Valid To' date";
    field = "validTo";
  } else if (moment(record.validTo).isBefore(record.validFrom)) {
    error = true;
    errorMessage = "The 'Valid To' date cannot be before the 'Valid From' date";
    field = "validTo";
  }

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage, field });
    if (props.onChange) {        
      props.onChange({ error, errorMessage, field });
    }
  }

  return (
    <div style={{display:"none"}}>
      {state.errorMessage}
    </div>
  );

}

export default FuelRateDuplicateDialogValidator;